// =====================================================================================
// FILE: src/utils/assetUtils.js
// =====================================================================================

export function assetIdOf(a) {
  if (!a) return null;
  if (typeof a === "string") return a;
  return a.id || a.recordId || a.recordID || a.value || null;
}

export function normalizeAsset(a) {
  if (!a) return null;

  if (typeof a === "string") {
    return { id: a, title: a, destination: "", thumb: "" };
  }

  const id = assetIdOf(a);
  if (!id) return null;

  return {
    id,
    title: a.title || a.name || a.filename || a.fileName || id,
    thumb: a.thumb || a.thumbnail || a.thumbUrl || a.url || "",
    destination: a.destination || a.dest || a.location || "",
  };
}
